import type { GlobalTypes, WalletTypes } from '@modules';
import { LoadersType } from '@modules/builders';
import { CryptoCurrencyEnum } from '@modules/global/types';

import { asyncActions } from './actions';

export type WalletStateType = {
  loaders: LoadersType<typeof asyncActions>;
  fiatCurrencies: GlobalTypes.FiatCurrencyEnum[];
  data?: WalletTypes.GETWalletResponse;
  limits: WalletTypes.GETWalletLimitsResponse;
  topupAddressData: {
    [key in CryptoCurrencyEnum]?: WalletTypes.GetTopupAddressResponse;
  };
  rapyd: {
    methods: {
      id: string;
      label: string;
      icon: string;
    }[];
  };
};

export const initialState: WalletStateType = {
  loaders: {},
  fiatCurrencies: [],
  limits: {
    sell: {},
    buy: {},
    withdraw: {},
  },
  topupAddressData: {},
  rapyd: {
    methods: [],
  },
};

export default initialState;
